import actions from "./actions";

const initState = {
  chatrRechargeReportResult: [],
  loading: false,
  error: null,
};

export default function reducer(state = initState, action) {
  switch (action.type) {
    case actions.GET_CHATR_RECHARGE_REPORT_REQUEST_LIST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.GET_CHATR_RECHARGE_REPORT_REQUEST_LIST_SUCCESSFUL:
      return {
        ...state,
        loading: false,
        error: null,
        chatrRechargeReportResult: action.payload.data,
      };
    case actions.GET_CHATR_RECHARGE_REPORT_REQUEST_LIST_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
}
